export default from './DownPaymentTargetQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/DownPaymentTargetQuestion/index.js